export enum SURVEY_COMPLETION_TYPE {
  COMPLETE_RESPONSES = 'has complete responses',
  INCOMPLETE_RESPONSES = 'has incomplete responses',
}
